module.exports = __webpack_public_path__ + "img/0-124.8ace5bc3.jpg";